import { useAuth } from '@/state/auth';
import type { UserType } from '@/types';

export function useMaskingUserType(): UserType {
  const { userType, isDemoUser, isDemoOrg } = useAuth();
  return isDemoUser || isDemoOrg ? 'customer' : userType;
}
